const KEYWORDS = [
  'select',
  'from',
  'inner join',
  'left join',
  'right join',
  'full join',
  'cross join',
  'join',
  'on',
  'where',
  'group by',
  'order by',
  'having',
  'limit',
  'offset',
  'union all',
  'union',
  'returning',
] as const

const KEYWORD_RE = new RegExp(`\\s+(${KEYWORDS.map(k => k.replace(/\s+/g, '\\s+')).join('|')})\\b`, 'gi')

const quoteLiteral = (v: unknown): string => {
  if (v === null || v === undefined) return 'NULL'
  if (typeof v === 'number') return Number.isFinite(v) ? String(v) : 'NULL'
  if (typeof v === 'boolean') return v ? '1' : '0'
  if (v instanceof Date) return `'${v.toISOString()}'`
  if (typeof v === 'bigint') return v.toString()
  if (ArrayBuffer.isView(v) || v instanceof ArrayBuffer) return `X'<binary>'`
  if (typeof v === 'object') return `'${JSON.stringify(v).replace(/'/g, "''")}'`
  return `'${String(v).replace(/'/g, "''")}'`
}

export const inlineSqlParams = (sql: string, parameters: readonly unknown[]): string => {
  let i = 0
  return sql.replace(/\?/g, () => (i < parameters.length ? quoteLiteral(parameters[i++]) : '?'))
}

export const formatSql = (sql: string): string =>
  sql.replace(KEYWORD_RE, (_, kw: string) => `\n${kw.toLowerCase()}`).trim()

export const formatSqlForLog = (sql: string, parameters: readonly unknown[]): string =>
  formatSql(inlineSqlParams(sql, parameters))
